// extracted by mini-css-extract-plugin
export default {"MobileAppSMSLinkForm":"k8Sie","phoneInput":"LK5Vc","getLinkButton":"EuzZL","buttonContent":"qTI7d","skeleton-progress":"jV4pi"};